export { useDeviceStateFor, iconFor } from './deviceState'
export { exportCSV } from './csv'
export { toFriendlyDate, toFriendlyTime } from './formatDate'
export { useBLE, BLEProvider } from './ble'
export { toHash } from './toHash'
export { default as wrap } from './wrap'

export const apiError = response => console.error('API call failed.', response)

// Translates a snake_cased string to camelCase
// If you pass in an object, this will act as an alias to the camelizeObject() function above.
export function camelize(str, isDeep=true) {
  if (str == null) return str
  if (typeof str == 'object') return camelizeObject(str, isDeep)
  let words = str.split('_')
  let first = words.shift()
  return first + words.map(w => w[0].toUpperCase() + w.slice(1)).join('')
}

export function snakify(str, isDeep=true) {
  if (str == null) return str
  if (typeof str == 'object') return snakifyObject(str, isDeep)
  let finalString = (str[0] || '').toLowerCase()
  for (let i = 1; i < str.length; i++) {
    const lowered = str[i].toLowerCase()
    if (str[i] == str[i].toUpperCase() && str[i] != lowered) {
      if (str[i-1] != str[i-1].toUpperCase()) finalString += '_'
      else if (str[i+1] && str[i+1] != str[i+1].toUpperCase()) finalString += '_'
    }
    finalString += lowered
  }
  return finalString
}

// deeply translates an object's property names/keys from snake_case to camelCase, or vice-versa
// Does NOT translate strings. Only keys.
function translateObjKeys(obj, translator, isDeep=true) {
  if (obj == null) return obj
  if (Array.isArray(obj)) {
    if (!isDeep) return obj
    let newArray = []
    for (let i=0; i<obj.length; i++)
      newArray.push((typeof obj[i] == 'object') ? translateObjKeys(obj[i], translator, isDeep) : obj[i])
    return newArray
  }

  // Don't camelize strings. Only an object's properties/keys.
  // Use camelize() below if you want to convert a string.
  if (typeof obj == 'string') return obj

  let newObj = { }
  Object.keys(obj).forEach(k => {
    let value = obj[k]
    if (typeof value == 'object' && isDeep)
      value = translateObjKeys(value, translator, isDeep)
    newObj[translator(k)] = value
  })
  return newObj
}

// deeply translates an object's property names/keys from snake_case to camelCase, or vice-versa
// Does NOT translate strings. Only keys.
export const camelizeObject = (obj, isDeep=true) => {
  try { return translateObjKeys(obj, camelize, isDeep) }
  catch (_e) { console.warn('error camelizing:', obj); console.trace() }
}
export const snakifyObject = (obj, isDeep=true) => {
  try { return translateObjKeys(obj, snakify, isDeep) }
  catch (_e) { console.warn('error snakifying:', obj); console.trace() }
}
